import Photo from '../../../components/photo/Photo.vue';

const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export default {
  components: { Photo },
  data() {
    return {
      overlayId: 'imageFullScreen',
      valid: false,
      profile: {},
      avatar_local: [],
      phoneMask: '',
      rules: {
        required: value => !!value || 'Поле должно быть заполнено',
        email: value => pattern.test(value) || 'Поле E-mail заполнено с ошибками',
      },
    };
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    isAuthenticated() {
      return this.$store.getters.isAuthenticated;
    },
    loading() {
      return this.$store.state.loading;
    },
    settings() {
      return this.$store.state.settings;
    },
  },
  methods: {
    setPhoneMask() {
      const masks = {
        russia8: '8 (###) ###-####',
        russia7: '+7 (###) ###-####',
        belarus: '+375 (##) ###-####',
      };

      // eslint-disable-next-line no-unused-vars
      const russia7Regex = /^\+?7/; // Номера РФ начинаются с 7
      const russia8Regex = /^8/; // Номера РФ начинаются с 8
      const belarusRegex = /^\+?37?5?/; // Номера Беларуси начинаются с 375

      if (russia8Regex.test(this.profile.phone_mobile)) {
        return masks.russia8;
      }
      if (belarusRegex.test(this.profile.phone_mobile)) {
        return masks.belarus;
      }

      return masks.russia7;
    },
    createUser() {
      this.profile = { ...this.user };

      if (this.profile.birthday_on) {
        this.birthday_on = this.parseDate(this.profile.birthday_on);
      }
      this.phoneMask = this.setPhoneMask();
    },
    profileSubmit() {
      const app = this;
      if (this.$refs.form.validate() && this.isAuthenticated) {
        const profile = {
          profile_id: app.profile.profile_id,
          birthday_on: app.birthday_on,
          gender: app.profile.gender,
          address: app.profile.address,
          phone_mobile_local: app.profile.phone_mobile,
          phone_local: app.profile.phone,
          email: app.profile.email,
          avatar_local: app.avatar_local,
        };
        app.$store.getters.axl.post('profiles/api/auth/profile-edit', profile)
          .then(async () => {
            app.$store.dispatch('ShowInfo', 'Ваш профиль был успешно обновлён');
            await app.$store.dispatch('GetProfile');
            app.$router.push({ name: 'dashboard' });
          })
          .catch((error) => {
            app.$store.dispatch('HandleError', error);
          });
      } else {
        app.$store.dispatch('HandleError', 'Ошибка отправки формы');
      }
    },
    openFullScreen(imgSrc) {
      const overlay = document.createElement('div');
      overlay.id = this.overlayId;
      overlay.style.position = 'absolute';
      overlay.style.background = '#00000073';
      overlay.style.width = '100%';
      overlay.style.height = '100%';
      overlay.style.top = '0';
      overlay.style.left = '0';
      overlay.style.zIndex = '500';
      overlay.style.display = 'flex';
      overlay.style.justifyContent = 'center';
      overlay.style.alignItems = 'center';

      const imageContainer = document.createElement('div');
      imageContainer.style.position = 'absolute';
      imageContainer.style.backgroundSize = 'contain';
      imageContainer.style.backgroundPosition = 'center';
      imageContainer.style.opacity = '1';
      imageContainer.style.height = '30%';

      const image = document.createElement('img');
      image.style.height = '100%';
      image.style.width = '100%';
      image.style.objectFit = 'cover';
      image.src = imgSrc;

      imageContainer.appendChild(image);

      const closeButton = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      closeButton.setAttribute('width', '26');
      closeButton.setAttribute('height', '26');
      closeButton.setAttribute('viewBox', '0 0 26 26');
      closeButton.setAttribute('fill', 'none');

      closeButton.style.position = 'absolute';
      closeButton.style.right = '-12px';
      closeButton.style.top = '-12px';
      closeButton.style.cursor = 'pointer';
      closeButton.addEventListener('click', () => {
        const foundOverlay = document.getElementById(this.overlayId);
        if (foundOverlay) {
          document.body.removeChild(foundOverlay);
        }
      });

      const path1 = document.createElementNS('http://www.w3.org/2000/svg', 'path');
      path1.setAttributeNS(null, 'd', 'M26 13C26 20.1797 20.1797 26 13 26C5.8203 26 0 20.1797 0 13C0 5.8203 5.8203 0 13 0C20.1797 0 26 5.8203 26 13Z');
      path1.setAttributeNS(null, 'fill', '#D60000');

      const path2 = document.createElementNS('http://www.w3.org/2000/svg', 'path');
      path2.setAttributeNS(null, 'd', 'M10.6818 12.966L7.47728 9.7797C6.84091 9.01124 6.84091 8.24286 7.47728 7.47456C8.25 6.84181 9.02272 6.84181 9.79544 7.47456L13 10.7288L16.2046 7.54225C16.9773 6.9095 17.75 6.9095 18.5227 7.54225C19.1591 8.31071 19.1591 9.07909 18.5227 9.84739L15.3182 12.966L18.5227 16.1525C19.1591 16.9209 19.1591 17.6893 18.5227 18.4576C17.75 19.0904 16.9773 19.0904 16.2046 18.4576L13 15.3389L9.79544 18.5254C9.02272 19.1582 8.25 19.1582 7.47728 18.5254C6.84091 17.7571 6.84091 16.9887 7.47728 16.2203L10.6818 12.966Z');
      path2.setAttributeNS(null, 'fill', 'white');

      closeButton.appendChild(path1);
      closeButton.appendChild(path2);

      imageContainer.appendChild(closeButton);

      overlay.appendChild(imageContainer);
      document.body.appendChild(overlay);
    },
  },
  mounted() {
    if (this.isAuthenticated) {
      this.$store.dispatch('eps/GetOrders', this.user.profile_id);
      this.createUser();
    }
  },
};
